import { Stack, Inline, Text } from 'braid-design-system';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import AmericanExpressSvg from 'src/images/amex.svg';
import MasterCardSvg from 'src/images/mastercard.svg';
import VisaSvg from 'src/images/visa.svg';

export const AcceptedCards = () => (
  <Stack space="xsmall">
    <Text>We accept:</Text>

    <Inline space="xsmall">
      <CustomSvg svg={VisaSvg} width={50} />
      <CustomSvg svg={AmericanExpressSvg} width={50} />
      <CustomSvg svg={MasterCardSvg} width={50} />
    </Inline>
  </Stack>
);
